import { Typography } from "@mui/material";
import { Conversation } from "../types/queries";
import { useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { getInboxLastMessagePreview, isSystemMessage } from "../helpers";
import { selectComposerDraft } from "../messagingSlice";

type Props = {
  conversation: Conversation;
};

const InboxRowLastMessage = ({ conversation }: Props) => {
  const { user } = useAppSelector((state) => state.user);
  const { t } = useTranslation("messaging");
  const draft = useAppSelector((state) =>
    selectComposerDraft(state, conversation.id),
  );

  return (
    <Typography
      variant="body2"
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        color: "primary.main",
        flex: "1 1 auto",
        minWidth: 0,
        fontWeight: !!conversation.unreadMessageCount ? 600 : 400,
      }}
    >
      {getInboxLastMessagePreview({
        lastMessage: conversation.lastMessage,
        currentUserId: user?.id,
        draft,
        isSystem: isSystemMessage(conversation.initiator),
        youLabel: t("you"),
        draftLabel: t("draft"),
      })}
    </Typography>
  );
};

export default InboxRowLastMessage;
